'use client';

import React__default, { useContext, useMemo } from 'react';
import { ParentItemWrapper, Label, RemoveSpan } from '../../InputContainer.css.js';
import CheckTagIcon from '../../../../../Images/CheckTagIcon/index.js';
import { CascaderContext } from '../../../../context/reducer.js';
import { ACTIONS } from '../../../../context/actions.js';
import { deepCloneArray } from '../../../../../TreeSelect/helpers.js';

var ParentItem = function (params) {
    var _a = useContext(CascaderContext), props = _a.props, state = _a.state, dispatch = _a.dispatch;
    var id = params.id, label = params.label, _b = params.isHaveRemoveIcon, isHaveRemoveIcon = _b === void 0 ? false : _b;
    var onConfirm = props.onConfirm, selectOptions = props.selectOptions, selectLayout = props.selectLayout;
    var value = state.value;
    var onRemoveItem = function (e) {
        e.stopPropagation();
        dispatch({
            type: ACTIONS.REMOVE_PARENT_ID,
            payload: id
        });
        var clonedTemporary = deepCloneArray(value);
        var filteredParents = clonedTemporary.filter(function (item) { return item.parentId !== id; });
        onConfirm && onConfirm(filteredParents);
    };
    return useMemo(function () { return (React__default.createElement(ParentItemWrapper, { "data-item-id": id, isSingle: selectOptions.isSingleSelect, isHaveRemoveIcon: isHaveRemoveIcon, selectLayout: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type },
        React__default.createElement(Label, null, label),
        isHaveRemoveIcon && (React__default.createElement(RemoveSpan, { onClick: onRemoveItem },
            React__default.createElement(CheckTagIcon, null))))); }, [id, label, value]);
};

export { ParentItem as default };
//# sourceMappingURL=index.js.map
